import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-12","key":"svg-0"}],["path",{"d":"M3 13h18","key":"svg-1"}],["path",{"d":"M8 21h8","key":"svg-2"}],["path",{"d":"M10 17l-.5 4","key":"svg-3"}],["path",{"d":"M14 17l.5 4","key":"svg-4"}]]

const IconDeviceImac = createReactComponent('outline', 'device-imac', 'DeviceImac', __iconNode);

export default IconDeviceImac;